import React from 'react';
import { Box, CircularProgress, Skeleton, Typography } from '@mui/material';
import { formatCurrencyBasedOnCountryCode } from 'src/utils/functions';
import { useSelector } from 'react-redux';

export const MapListingCountInfoBox = ({
  open,
  multipleMarkersCallLoading,
  listingsLength,
}: {
  open: boolean;
  multipleMarkersCallLoading: boolean;
  listingsLength: number;
}) => {
  const visibleMapSupply = useSelector(state => (state as any).dashboard.visibleMapSupply);
  const isUserAllowed = useSelector(state => (state as any).dashboard.isUserAllowed);
  const search = useSelector(state => (state as any).dashboard.search);
  const useFullMarkers = useSelector(state => (state as any).dashboard.useFullMarkers);

  const isLoading = useFullMarkers
    ? multipleMarkersCallLoading
    : visibleMapSupply.loading || visibleMapSupply.data == null;
  const count = useFullMarkers ? listingsLength : visibleMapSupply.data;

  if (!open) return <></>;

  return (
    <Box
      sx={{
        marginRight: '10px',
        background: '#0008',
        borderRadius: 4,
        padding: '5px 10px',
        position: 'absolute',
        top: '25px',
        left: '7px',
        zIndex: 3,
        backdropFilter: 'blur(4px)',
        height: '40px',
        overflow: 'hidden',
        display: !multipleMarkersCallLoading || !isUserAllowed ? 'block' : 'none',
      }}
    >
      {isLoading ? (
        useFullMarkers ? (
          <Typography variant="body2" style={{ color: '#fff' }}>
            Fetching listings{' '}
            {search.data
              ? 'in ' + search.data.displayName
                ? search.data.displayName
                : search.data.name
              : ''}
            ... Please wait while we gather the latest data{' '}
            <CircularProgress size={20} sx={{ color: 'white' }} />
          </Typography>
        ) : (
          <Skeleton variant="text" height="20px" sx={{ padding: '-5px -10px' }}>
            <Typography variant="body2" style={{ color: '#fff' }}>
              {/* the below text is dummy. Just to give a default width tot he component */}
              <div>Airbnb listings are available in this area. Zoom in to see.</div>
            </Typography>
          </Skeleton>
        )
      ) : (
        <Typography variant="body2" style={{ color: '#fff' }}>
          <div>
            <span>{formatCurrencyBasedOnCountryCode(count, 'USD')}</span>{' '}
            <span>Airbnb listings are available in this area.</span>
            <br />
            <span>Zoom in to see.</span>
          </div>
        </Typography>
      )}
    </Box>
  );
};
